<template>
    <SidePanelCheck :checked="observationCount > 0" @click="clicked" @right-click="rightClicked" />
</template>

<script setup>
import { computed } from "vue";
import { globalState } from '@/scripts/store';
import SidePanelCheck from "../SidePanelCheck.vue";

const emit = defineEmits(['change']);

const props = defineProps({
    observation: Object,
    participant: Object
});

function clicked() {
    changeObservation(1);
}

function rightClicked() {
    changeObservation(-1);
}

function changeObservation(change) {
    emit('change', { change: change, observation: props.observation, participant: props.participant })
}

const observationCount = computed(() => {
    const studentUuid = props.participant.userData?.studentUuid || props.participant.user_name;
    const studentObservations = globalState.value.studentObservations[studentUuid];
    return studentObservations ? studentObservations[props.observation.shortname] : 0;
});

</script>